import React, { useEffect, useState, useCallback, Arrow } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
// import { MainLayOut } from "../../components/shares/layout";
import Map from "../../components/map/Map";
import { BASE_URL,BASE_IMAGE_URL } from "../../service/apiConfig";
import {
  Col,
  Row,
  Typography,
  Card,
  List,
  Image,
  Tabs,
  Button,
  Rate,
  Modal,
  Carousel,
  Input,
  Space,
  Select,
  Pagination,
} from "antd";
import ViewDetail from "./viewdetail";
import locationServiceApi from "../../service/locationserviceService";
import eventServiceApi from "../../service/eventService";
import provinceApi from "../../service/provinceService";
import reviewApi from "../../service/ReviewService";
import locationTourApi from "../../service/locationTourService";
import bannerServiceApi from "../../service/bannerService";
import { EyeOutlined } from "@ant-design/icons";
import serviceCategoryApi from "../../service/serviceCategoriesApi";
import eventCategoryApi from "../../service/eventCategoriesService";
import VirtualList from "rc-virtual-list";
import "./index.css";
import { useSelector } from "react-redux";
import img1 from "../../assets/image 11.png";
import imgAdsDefault from "../../assets/ads_tripze.png";

import { Trans, useTranslation } from "react-i18next";
import Parser from "html-react-parser";
import Utils from "../../components/shares/utils"
import { updateCurrentLocation } from "../../features/currentLocationRedux/currentLocation";
import { useDispatch } from "react-redux";
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import itemOpenHour from "../../components/card/itemOpenHour";


const { TabPane } = Tabs;
const TOTAL_ITEMS_SHOWING = 10;

export default function HomePageBackup() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { paramCategoryId, locationId , tab } = useParams();

  const currentLocation = useSelector((state) => state.currentLocation);
  
  const currentLanguage = useSelector((state) => state.currentLanguage);

  const [locationData, setLocationData] = useState([]);

  const [locationProvinceNearest, setLocationProvinceNearest ] = useState([]);

  const [advertising, setAdvertising] = useState([]);

  const [locationTours, setListLocationTours] = useState([]);

  const [serviceCategory, setServiceCategory] = useState([]);
  const [eventCategory, setEventCategory] = useState([]);

  const [listLocationService, setListLocationService] = useState([]);
  const [listEvent, setListEvent] = useState([]);
  const [listBanner, setListBanner] = useState([]);

  const [commentList, setCommentList] = useState([]);
  const [id, setId] = useState(0);
  const [categoryId, setCategoryId] = useState(-1);
  const [aboutProvince, setAboutProvince] = useState(null)
  const [keySearch, setKeySearch] = useState("");
  const [latSearch, setLatSearch] = useState("");
  const [longSearch, setLongSearch] = useState("");
  const [activeTab, setActiveTab] = useState("0");
  const [provinceData, setProvinceData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [initLoadLocationIp, setInitLoadLocationIp] = useState(false);
  
  const { Option } = Select;
  const body = {
    latitude:
      currentLocation?.latitude != "" ? currentLocation?.latitude : latSearch,
    longitude:
      currentLocation?.longitude != ""
        ? currentLocation?.longitude
        : longSearch,
    page: 1,
    pageSize: TOTAL_ITEMS_SHOWING,
    language: currentLanguage.language,
  };

  const onLoadMore = () => {
    setCurrentPage(currentPage + 1)
  }

  const parserDataItem = (item) => {
    const temp = {
      ...item,
      pictureFilename:
        item?.pictureFilename != "" && item.pictureFilename != null
          ? JSON.parse(item?.pictureFilename)
          : null,
    }
    return temp
  }

  const getProvinceInfo = () => {    
    if(!initLoadLocationIp)
    provinceApi.getRegionByIp().then((res) => {
      setInitLoadLocationIp(true)
      const loc = res.loc != '' ? res.loc.split(',') : '';
      const result = {
        // city: res.city,
        // region: res.region,
        // country: res.country,
        // postal: res.postal,
        latitude : loc[0],
        longitude : loc[1],
      } 
      setLatSearch(result.latitude);
      setLongSearch(result.longitude);
      const location ={
        lat: result.latitude, 
        lng: result.longitude
      }
      dispatch(updateCurrentLocation(location));
      getProvinceNearest(result.latitude, result.longitude, false)    
    });
  }
  
  const getProvinceNearest = (latitude, longitude, allowIncludeCurrent) => {
    const dataBody = {
      latitude:  latitude,
      longitude: longitude,
      page: currentPage,
      pageSize: TOTAL_ITEMS_SHOWING,
      language: currentLanguage.language,
      allowIncludeCurrent: allowIncludeCurrent
    }
    
    provinceApi.getProvinceNesrest(dataBody).then((response) => {
      const data = response?.data 
      if (data?.length > 0){
          let temp = null
          const listProvinceTemp = []; 
          let index = 0 ;
          data.forEach((item) => {
            if( temp == null ) temp = parserDataItem(item)          
            else{
              const tempData = parserDataItem(item)
              listProvinceTemp.push(tempData);
            }              
          });

          setLocationProvinceNearest(listProvinceTemp)
          setLocationData([temp])
          setAboutProvince(temp)
      }
    })
  }

  useEffect(() => {
    setAdvertising([])
    const body = {
      latitude:
        currentLocation?.latitude != "" ? currentLocation?.latitude : latSearch,
      longitude:
        currentLocation?.longitude != ""
          ? currentLocation?.longitude
          : longSearch,
      page: currentPage,
      pageSize: TOTAL_ITEMS_SHOWING,
      language: currentLanguage.language,
    };
    // change province 
    if (aboutProvince?.id ){    
      provinceApi.searchById(aboutProvince?.id, currentLanguage.language).then((res) => {
        const data = res.data
        if (data != null){                      
            const temp = parserDataItem(data)
            setLocationData([temp])
            setAboutProvince(temp)
        }
      })
    }

    if(activeTab == "0"){
      getProvinceInfo()
    }
    else if (activeTab == "1") {
      locationTourApi.getNearestLocation(body).then((response) => {
        setTotalItem(response.totalData);
        const listTemp = [];        
        response.data.forEach((item) => {
          const tempData = parserDataItem(item)
          listTemp.push(tempData);
        });
        const locations = currentPage == 1 ? listTemp : [...locationTours, ...listTemp];
        setListLocationTours(locations);
        setLocationData(locations);
      }, []);      
      locationTourApi.getAdsTour(currentLanguage.language).then((response) => {
        const listAds = [];
        response.data.forEach((item) => {
          const temp = parserDataItem(item)           
          listAds.push(temp);
        });
        setAdvertising(listAds)
      }).catch((err) => console.log('getAdsTour err ' + err))
    } else if (activeTab.startsWith('event')) { // activeTab === "event"
      const keyId = activeTab.split("-")[1]
      eventCategoryApi.getByEventCateId(keyId, body).then((response) => {
        setTotalItem(response.totalData);
        const listEventTemp = [];
        response.data?.forEach((item) => {
          const temp = parserDataItem(item)
          listEventTemp.push(temp);
        });
        const locationEvents = currentPage == 1 ? listEventTemp : [...listEvent, ...listEventTemp];
        setListEvent(locationEvents);
        setLocationData(locationEvents);
      })      
      eventCategoryApi.getAdsEvent(keyId, currentLanguage.language).then((response) => {
        const listAds = [];
        response.data.forEach((item) => {
          const temp = parserDataItem(item)         
          listAds.push(temp);
        });
        setAdvertising(listAds)
      }).catch((err) => console.log('getAdsEvent err ' + err))
    } else {
      const categoryId = activeTab.split("-")[1]
      serviceCategoryApi.getById(categoryId, body)
        .then((response) => {
          const listTourTemp = [];
          response.data.forEach((item) => {
            const temp = parserDataItem(item)          
            listTourTemp.push(temp);
          });
          const tours = currentPage == 1 ? listTourTemp : [...locationData, ...listTourTemp];
          setListLocationService( tours);
          setLocationData(tours);
        });
        serviceCategoryApi.getAdsService(categoryId, currentLanguage.language).then((response) => {
          const listAds = [];
          response.data.forEach((item) => {
            const temp = parserDataItem(item)           
            listAds.push(temp);
          });
          setAdvertising(listAds)
        }).catch((err) => console.log('getAdsEvent err ' + err))        
    }
    
    provinceApi.getAll('', currentLanguage.language).then((res) => {
      setProvinceData(res.data);
    });
    
    // replace api getEvent Category and AllServiceCategory
    serviceCategoryApi.getMenuAll(currentLanguage.language).then((response) => {
      setServiceCategory(response.data);
    });
    
    bannerServiceApi.getAll().then((response) => {
      setListBanner(response.data);
    });
    // //open view detail
   
  }, [currentLanguage.language, currentLocation, currentPage, activeTab]);

  const getCurrentTab = () => {
    let tabCategoryId = ''
    let tabName = ''
    if (activeTab == '1') {
      tabName = 'TOUR'
    }else if (activeTab.startsWith('event')) {      
      tabName = 'EVENT'
      tabCategoryId = activeTab.split("-")[1]
    }else {
      tabName = 'SERVICES'
      tabCategoryId = activeTab.split("-")[1]
    }

    return  {
      categoryId: tabCategoryId,
      type:  tabName
    }
  }

  useEffect(() => {
    //open view detail
    let categoryId = paramCategoryId 
    let type =  tab 
    if (locationId && type != '') {
      handleOpenViewDetail(locationId, categoryId, type.toUpperCase());       
    }  
  },[locationId, tab])

  const callbackTabClicked = (key, event) => {
    setCurrentPage(1);
    setActiveTab(key);
    setAdvertising([])
    if (key == "1") {
      setListLocationTours([]);
      locationTourApi.getNearestLocation(body).then((response) => {
        const listTour = [];
        setTotalItem(response.totalData);
        response.data.forEach((item) => {
          const temp = parserDataItem(item)          
          listTour.push(temp);
        });
        setListLocationTours(
          keySearch != ""
            ? listTour.filter(
                (x) => x.province != null && x.province.includes(keySearch)
              )
            : listTour
        );
        setLocationData(
          keySearch != ""
            ? listTour.filter(
                (x) => x.province != null && x.province.includes(keySearch)
              )
            : listTour
        );
      });
      locationTourApi.getAdsTour(currentLanguage.language).then((response) => {
        const listAds = [];
        response.data.forEach((item) => {
          const temp = parserDataItem(item)          
          listAds.push(temp);
        });
        setAdvertising(listAds)
      }).catch((err) => console.log('getAdsTour err ' + err))
    } else if (key.startsWith('event')) {  // (key == "event") {
      setListEvent([]);
      const keyId = key.split("-")[1];
      eventCategoryApi.getByEventCateId(keyId, body).then((response) => {
        setTotalItem(response.totalData);
        const listEvent = [];
        response.data?.forEach((item) => {
          const temp = parserDataItem(item)         
          listEvent.push(temp);
        });
        
        setListEvent(
          keySearch != ""
            ? listEvent.filter(
                (x) => x.province != null && x.province.includes(keySearch)
              )
            : listEvent
        );
        setLocationData(
          keySearch != ""
            ? listEvent.filter(
                (x) => x.province != null && x.province.includes(keySearch)
              )
            : listEvent
        );
      });

      eventCategoryApi.getAdsEvent(keyId, currentLanguage.language).then((response) => {
        const listAds = [];
        response.data.forEach((item) => {
          const temp = parserDataItem(item)          
          listAds.push(temp);
        });
        setAdvertising(listAds)
      }).catch((err) => console.log('getAdsEvent err ' + err))
      
    } else if (key.startsWith('service')) { 
      const keyId = key.split("-")[1];
      setLocationData([]);
      serviceCategoryApi.getById(keyId, body).then((response) => {
        setTotalItem(response.totalData);
        const listTour = [];
        response.data.forEach((item) => {
          const temp = parserDataItem(item)          
          listTour.push(temp);
        });
        setListLocationService(
          keySearch != ""
            ? listTour.filter(
                (x) => x.province != null && x.province.includes(keySearch)
              )
            : listTour
        );
        setLocationData(
          keySearch != ""
            ? listTour.filter(
                (x) => x.province != null && x.province.includes(keySearch)
              )
            : listTour
        );
      });

      serviceCategoryApi.getAdsService(keyId, currentLanguage.language).then((response) => {
        const listAds = [];
        response.data.forEach((item) => {
          const temp = parserDataItem(item)         
          listAds.push(temp);
        });
        setAdvertising(listAds)
      }).catch((err) => console.log('getAdsEvent err ' + err))        

    }else{
      // setLocationData([aboutProvince])
      // setAboutProvince(event)
      // setLocationData(event)
    }
  };

  const ContainerHeight = "100vh";

  const [openViewDetail, setOpenViewDetail] = useState(false);

  const [tourData, setTourData] = useState();

  const [serviceData, setServiceData] = useState();
  const [eventData, setEventData] = useState();

  const navigatePageDetail = (id, categoryId, type) => {    
    const tabCate = id != null ? (type === 'TOUR' ? `/${type.toLowerCase()}/` :  `/${type.toLowerCase()}/` + categoryId + '/' ) : null 
    const to = { pathname: tabCate == null ?  '/' : tabCate + id };    
    navigate(to, { replace: true });
  }

  const handleOpenViewDetail = (id, categoryId, type) => {        
    navigatePageDetail(id, categoryId, type )
    if (type === "TOUR") {
      locationTourApi.getById(id, currentLanguage.language)
      .then(async (res) => {
          const dataTour = parserDataItem(res.data)
          
          setId(id);
          setCategoryId(-1)
          getReviewData(id, type);
          setTourData(dataTour);
        });
    } else if (type === "SERVICES") {
      locationServiceApi
        .getById(id, currentLanguage.language)
        .then(async (res) => {
          const dataService = parserDataItem(res.data)          
          getReviewData(id, type);
          setServiceData(dataService);
          setCategoryId(categoryId)
          setId(id);
        });
    } else {
      eventServiceApi
        .getById(id, currentLanguage.language)
        .then(async (res) => {
          const dataEvent = parserDataItem(res.data)
          getReviewData(id, type);
          setEventData(dataEvent);
          setCategoryId(0)
          setId(id);
        });
    }
  }

  const getReviewData = (id, type) => {
    reviewApi.getReview({ id, type }).then((res) => {
      if (res.data != null) {
        // setRating(parseFloat(res.data.totalRating));
        const listCmt = [];
        res.data.comment.forEach((item) => {
          const cmtData = {
            userName: item.userName,
            content: item.content,
            avatar: item.avatar,
            email: item.email,
            rating: item.rating,
            userId:item.userId,
            updatedAt: item.updatedAt,
          };
          listCmt.push(cmtData);
        });
        setCommentList(listCmt);
        setOpenViewDetail(true);
      } else {
        setCommentList([]);
        setOpenViewDetail(true);
      }
    });
  };

  const handleCloseViewDetail = () => {
    // const to = { pathname: '/' };
    // navigate(to, { replace: true });
    navigatePageDetail(null, null ,null)

    setOpenViewDetail(false);
    setCommentList([]);
    setTourData();
    setServiceData();
    setEventData();
  };

  const onSearch = (value) => {
    
    const findProvince = provinceData.find((x) => x.id === value);
    let temp = {}
    if(findProvince){
      const item = findProvince
      temp = parserDataItem(item)      
      setAboutProvince(temp)
      setLocationData([temp])
    }
    
    setLatSearch(findProvince.latitude);
    setLongSearch(findProvince.longitude);
    const location ={
      lat: findProvince.latitude, 
      lng: findProvince.longitude      
    }
    dispatch(updateCurrentLocation(location));
    // setActiveTab("0")
    callbackTabClicked(activeTab);
    // callbackTabClicked("0",temp);
  };

  const showContentPhoneNumberAds = (props) => {
    const  {
      phone,
      description
    } = props

    return (phone == null || phone == '') ?  Parser(description ?? '')  : phone
    
    // return (phone == null || phone == '') ? ((description != null &&  description === '') ? Parser(description) : '') : phone
  }
  
  const renderAds = () => {
      return (
            <div style={{ position: "relative", borderRadius: '15px',flex: "none", alignContent:'center', marginTop:15, marginLeft: 15}}>             
               {advertising?.length > 0 ? <Carousel autoplay={true} className="carousel-home-ads">
                {advertising?.map((item, index) => (                            
                  <div style={{borderRadius: '15px'}} 
                  onClick={(e) => {
                    if (!Utils.isShowMyAds(item)){
                      console.log(' click ads')
                      const  {
                        categoryId,
                        type
                      } = getCurrentTab()
                      
                      handleOpenViewDetail(item.id, categoryId , type)
                    }                    
                  }}> 
                      {Utils.isShowMyAds(item) ? <div className="info-ads-card" >                             
                        <span className="info-ads-card-header-font" >{item?.title} </span>
                      </div> : null }
                      {Utils.isShowMyAds(item) ? <div className="info-ads-card-title">                            
                      <span className="info-ads-card-title-font" > {showContentPhoneNumberAds(item)} </span>
                      </div> : null }
                    <img style={{borderRadius: '15px' }} src={BASE_IMAGE_URL + item?.pictureFilename[0]}></img>                   
                          {/* </a> */}
                   </div>
                 ))}                
              </Carousel> : null }
            </div> 
      )
  }

  const getItems = () => Array(20).fill(0).map((_, ind) => ({ id: `element-${ind}` }));
  const Arrow = ({ text, className }) => {
    return <div className={className}>{text}</div>;
  };
  const leftArrow = () => {
   
    return (
      <Arrow   >
        Left
      </Arrow>
    );
  }
  
const  rightArrow = () => {
    // const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);
  
    return (
      <Arrow  >
        Right
      </Arrow>
    );
}

return (
    <div>
      <div style={{ position: "relative", flex: "none" }}>
        <Carousel className="carousel-home" autoplay={true} pauseOnHover={false}>
          {listBanner?.map((banner) => <a key={banner.id} href={banner.url} target="_blank"><img src={BASE_IMAGE_URL + banner.picture}></img></a>)}
          {listBanner.length == 0 && <>
            <img src={img1}></img>
          </>
          }
        </Carousel>
        <Card className="select-card">
          <Row justify="center">
            <span className="select-card-title">
              {t("content.discoverInterestingPlaces")}
            </span>
            <div className="select-province-form">
              <Select
                onChange={onSearch}                
                onClick={()=>{
                  provinceApi.getAll('', currentLanguage.language).then((res) => {
                    setProvinceData(res.data);
                  })
                }}
                className="select-province"
                placeholder={Parser(t("content.searchToProvince"))}
                optionFilterProp="children"
                filterOption={(input, option) => option.children.includes(input)}
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }>
                {provinceData.map((x) => (
                  <Option key={x.id} value={x.id}>{x.name}</Option>
                ))}
              </Select>
              <Button className="select-card-button">
                {t("content.btnSearch")}
              </Button>
            </div>
          </Row>
        </Card>
      </div>
      <div className="location-panel">
        <div className="location-panel-filter" id="location-panel-filter">
          <Tabs
            tabBarStyle={{height: '50px'}}
            type="card"
            defaultActiveKey={activeTab}            
            size="large"
            onTabClick={callbackTabClicked}
          >
            {/** tab Province */}
            <TabPane tab={aboutProvince?.name} key="0" style={{marginLeft: "15px"}}>
            <Row justify="space-between" className="place-list">
              <Col sm={20} md={24}>
                <Carousel style={{ width: "100%",borderRadius: 15 }} autoplay pauseOnHover={false}>
                    {aboutProvince?.pictureFilename.map((x) => (
                    <div key={x} className="info" style={{borderRadius: 15, marginTop: 15
                    }}>
                       <img style={{borderRadius: '15px', width: '100%', height: 500, marginTop: 15 }} src={BASE_IMAGE_URL + x}></img>
                      {/* <Image                      
                        style={{borderRadius: 15, marginTop: 15
                        }}
                        width={"100%"}
                        src={`${BASE_IMAGE_URL}${x}`}
                      /> */}
                    </div>
                  ))}
                </Carousel>
              </Col>
              </Row>
              <Row justify="space-between">
              <div className="info">
                <div>
                  <span style={{fontWeight: "500", fontSize: "15px" }}>{t("content.provinceAbout")}</span><br/>
                  <span style={{fontWeight: "300", fontSize: "15px" }}>{aboutProvince?.description && Parser(aboutProvince?.description)}</span>
                </div>
                {aboutProvince?.area ? <div>                  
                  <span style={{fontWeight: "500", fontSize: "15px" }}>{t("content.provinceArea")}</span>
                  <span style={{fontWeight: "300", fontSize: "15px" }}>{aboutProvince?.area} Km<sup>2</sup></span>
                </div> : null
                }
                {aboutProvince?.population ?
                <div>
                  
                  <span style={{fontWeight: "500", fontSize: "15px" }}>{t("content.provincePopulation")}</span>
                  <span style={{fontWeight: "300", fontSize: "15px" }}>{aboutProvince?.population}</span>
                </div> : null
                }
                {aboutProvince?.foundedYear ? <div>
                  
                  <span style={{fontWeight: "500", fontSize: "15px" }}>{t("content.provinceFoundedYear")}</span>
                  <span style={{fontWeight: "300", fontSize: "15px" }}>{aboutProvince?.foundedYear}</span>
                </div> : null
                }                
                </div>
              </Row>
              <Row justify="space-between">
              <Col sm={20} md={24}>
                <div style={{marginTop: 20}}>    
                  <span style={{fontWeight: "400", fontSize: "25px" }}>{t('content.nearbyPlacesProvince') + aboutProvince?.name}</span>
                </div>
               <ScrollMenu >
                {locationProvinceNearest?.map((item) => (
                  <div style={{position: "relative", marginTop: 20, marginBottom: 40}}>
                  <div style={{position: "relative", flex: "none", borderRadius: 15, marginRight: 15, marginTop: 15, marginBottom: 15, cursor:'pointer'}}
                  onClick={() => {                    
                    getProvinceNearest(item.latitude, item.longitude ,true)
                  }}
                  >
                      <div>
                        <div className="info-province-card" >
                            <span className="info-province-card-header-font" >{item?.name} </span>
                        </div>
                        <div className="info-province-card-distance" >                             
                            <span className="info-province-card-header-font" >{Utils.parseDistanceToString(item?.distance)}</span>
                        </div>
                      </div>
                      <img style={{borderRadius: '15px', width: 200, height: 200 }} src={BASE_IMAGE_URL + item?.pictureFilename[0]}></img>
                  </div>
                 </div>
                 
                ))}
              </ScrollMenu>              
              </Col>
              </Row>
                 
            </TabPane>
            {/** tab Tour */}
            <TabPane tab={t("content.tour")} key="1">
                {renderAds()}
              <List className="place-list" key="list-1">             
                <VirtualList data={locationTours} itemKey="email">                  
                  {(item) => (
                    <List.Item key={item.title}>
                      <div className="place-item">
                        <div className="pic">
                          {item.pictureFilename != null &&
                          item.pictureFilename != "" ? (
                            <Image
                              src={`${BASE_IMAGE_URL}/${item.pictureFilename[0]}`}
                            />
                          ) : (
                            <Image
                              src={`${BASE_IMAGE_URL}/images/avatar.jpg`}
                            />
                          )}
                        </div>
                        <div className="info" onClick={() => {
                          handleOpenViewDetail(item.id, 1 , "TOUR");
                        }}>
                          
                          <div style={{ fontWeight: "500", fontSize: "15px" }}>{item.title}</div>
                          <div style={{fontSize: "15px" }}>{item.address}</div>                          
                          <div>
                              <span style={{ fontWeight: "500", fontSize: "15px" }}>
                              {item?.dateTimeOpenLunar != null ?  t("content.operatingDate") : t("content.operatingHours")}: 
                              </span>
                              <span style={{fontSize: "15px", marginLeft: "5px" }}>{ Utils.displayTimeStatus(item?.dateTimeOpen, item?.dateTimeClose)}</span>
                          </div>                          
                          <div>
                            <Rate disabled defaultValue={item?.totalRating} />
                            <i>
                              {
                                <>{Utils.parseDistanceToString(item.distance)}</>
                              }
                            </i>
                          </div>
                          <Button
                            icon={<EyeOutlined />}
                            className="btn btn-primary">
                            {t("content.viewDetail")}
                          </Button>
                        </div>
                      </div>
                    </List.Item>
                  )}
                </VirtualList>
                {(totalItem > currentPage * TOTAL_ITEMS_SHOWING) && <div className="load-more"><a onClick={() => onLoadMore()}>{t("content.loadMore")}</a></div>}
              </List>
            </TabPane>
            {/**  load tab event */}
            {eventCategory.map((category) => (
            <TabPane tab={category.name} key={"event-" + category.id}>     {/** tab={t("content.event")} key="event" >*/}
                {renderAds()}
              <List className="place-list" key={"list-event-" + category.id}>
                <VirtualList
                  data={listEvent}
                  itemHeight={47}
                  itemKey="id"
                >
                  {(item) => (
                    <List.Item key={item.id}>
                      <div className="place-item">
                        <div className="pic">
                          {item.pictureFilename != null &&
                          item.pictureFilename != "" ? (
                            <Image
                              src={`${BASE_IMAGE_URL}/${item.pictureFilename[0]}`}
                            />
                          ) : (
                            <Image
                              src={`${BASE_IMAGE_URL}/images/avatar.jpg`}
                            />
                          )}
                        </div>
                        <div className="info" onClick={() => {
                          handleOpenViewDetail(item.id, item?.eventCategoryId, "EVENT");
                        }}>
                          <div style={{ fontWeight: "500", fontSize: "15px" }}>{item.title}</div>
                          <div style={{fontSize: "15px" }}>{item.address}</div>
                        <div>
                          <span>
                          <h3>{t("content.operatingDate")}: </h3>
                          </span>
                          <span style={{ fontWeight: "500", fontSize: "15px" }}>{ Utils.displayDayItem(item?.dateTimeOpen, item?.dateTimeClose, currentLanguage.language)}</span>
                        </div>
                        <div>
                          <span>
                          <h3>{t("content.operatingHours")}: </h3>
                          </span>
                          <span style={{ fontWeight: "500", fontSize: "15px" }}>{ Utils.displayTimeStatus(item?.dateTimeOpen, item?.dateTimeClose)}</span>
                        </div>
                          
                          <div>
                            <Rate disabled defaultValue={item?.totalRating} />
                            <i>
                              {
                                <>{Utils.parseDistanceToString(item.distance)}</>
                              }
                            </i>
                          </div>
                          <Button
                            icon={<EyeOutlined />}
                            className="btn btn-primary">
                            {t("content.viewDetail")}
                          </Button>
                        </div>
                      </div>
                    </List.Item>
                  )}
                </VirtualList>
                {(totalItem > currentPage * TOTAL_ITEMS_SHOWING) && <div className="load-more"><a onClick={() => onLoadMore()}>{t("content.loadMore")}</a></div>}
              </List>
            </TabPane>
            ))}

            {serviceCategory.map((itemService) => (
              <TabPane tab={itemService.title} key={itemService.key}>  
              {renderAds()}
                <List className="place-list" key={"list-" + itemService.key}>
                 {/* key={"list-service-" + item.id}> */}
                  <VirtualList
                    data={itemService.tab === "service" ? listLocationService : listEvent}
                    itemHeight={47}
                    itemKey="email"
                  >
                    {(item) => (
                      <List.Item key={item?.title}>
                        <div className="place-item">
                          <div className="pic">
                            {item.pictureFilename != null &&
                            item.pictureFilename != "" ? (
                              <Image
                                src={`${BASE_IMAGE_URL}/${item.pictureFilename[0]}`}
                              />
                            ) : (
                              <Image
                                src={`${BASE_IMAGE_URL}/images/avatar.jpg`}
                              />
                            )}
                          </div>
                          <div className="info" onClick={() => {
                            handleOpenViewDetail(item.id, itemService.tab === "service" ? item?.serviceCategoryId : item?.eventCategoryId , itemService.tab === "service" ?  "SERVICES" : "EVENT");
                          }}>
                            <div style={{ fontWeight: "500", fontSize: "15px" }}>{item.title}</div>
                            <div style={{fontSize: "15px" }}>{item.address}</div>
                            {item?.eventCategoryId ? <div>
                              <span style={{ fontWeight: "500", fontSize: "15px" }}>
                              {t("content.operatingDate")}: 
                              </span>
                              <span style={{ marginLeft: "5px" }}>{ Utils.displayDayItem(item?.dateTimeOpen, item?.dateTimeClose, currentLanguage.language)}</span>
                            </div> : 
                            itemOpenHour(item, t)
                            // <div>
                            //   <span style={{ fontWeight: "500", fontSize: "15px" }}>
                            //   {Utils.showTitleOpenHour(t, item?.dateTimeOpen, item?.dateTimeClose)}
                            //   </span>
                            //   <span style={{ marginLeft: "5px", fontSize: "15px" }}>{ Utils.displayTimeStatus(item?.dateTimeOpen, item?.dateTimeClose)}</span>                              
                            // </div> 
                            }


                            <div>
                              <Rate disabled defaultValue={item?.totalRating} />
                              <i>
                                {
                                  <>{Utils.parseDistanceToString(item.distance)}</>
                                }
                              </i>
                            </div>
                            <Button
                              icon={<EyeOutlined />}
                              className="btn btn-primary">
                              {t("content.viewDetail")}
                            </Button>
                          </div>
                        </div>
                      </List.Item>
                    )}
                  </VirtualList>
                  {(totalItem > currentPage * TOTAL_ITEMS_SHOWING) && <div className="load-more"><a onClick={() => onLoadMore()}>{t("content.loadMore")}</a></div>}
                </List>
              </TabPane>
            ))}
            
          </Tabs>
        </div>
        <div className="location-panel-maps" id="location-panel-maps">
          <Map locationData={locationData} initLocation={{lat: latSearch,
          lng: longSearch }}
          callbackLoadFinish={() =>{
            setLongSearch('')
            setLatSearch('')
          }}
          />
        </div>
        {/* {openViewDetail ?  */}
        <Modal
          className="modal-view-details"
          visible={openViewDetail}
          onCancel={handleCloseViewDetail}
          footer={[]}
        >
          {tourData ? (
            <ViewDetail
              id={id}
              tourData={tourData}
              commentListInput={commentList}
              type="TOUR"
              language={currentLanguage.language}
            />
          ) : eventData ? (
            <ViewDetail
              id={id}
              tourData={eventData}
              commentListInput={commentList}
              type="EVENT"
              language={currentLanguage.language}
            />
          ) : (
            <ViewDetail
              id={id}
              categoryId={categoryId}
              tourData={serviceData}
              commentListInput={commentList}
              type="SERVICES"
              language={currentLanguage.language}
            />
          )}
        </Modal>
         {/* :  null } */}
      </div>
    </div>
  );
}
